import React, { useState, useRef } from 'react';
import '../Styles/event_form.css';

// Change this if your backend runs on a different host/port
const API_BASE_URL = "";

function EventPage() {
  const [formData, setFormData] = useState({
    fullName: '',
    designation: '',
    company: '',
    contactNumber: '',
    personalEmail: '',
    officialEmail: '',
    howDidYouKnow: '',
  });

  const [fileName, setFileName] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const fileInputRef = useRef(null);
  const formRef = useRef(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files && e.target.files[0];
    setFileName(file ? file.name : '');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    // Build multipart/form-data so the file upload works alongside the text fields
    const payload = new FormData();
    payload.append('fullName', formData.fullName);
    payload.append('designation', formData.designation);
    payload.append('company', formData.company);
    payload.append('contactNumber', formData.contactNumber);
    payload.append('personalEmail', formData.personalEmail);
    payload.append('officialEmail', formData.officialEmail);
    payload.append('howDidYouKnow', formData.howDidYouKnow);

    const file = fileInputRef.current?.files?.[0];
    if (file) {
      payload.append('image', file);
    }

    try {
      const res = await fetch(`${API_BASE_URL}/api/registrations`, {
        method: 'POST',
        body: payload,
      });

      if (!res.ok) {
        const errBody = await res.json().catch(() => ({}));
        throw new Error(errBody.error || 'Registration failed');
      }

      alert('Registration submitted successfully!');

      // Reset the form
      setFormData({
        fullName: '',
        designation: '',
        company: '',
        contactNumber: '',
        personalEmail: '',
        officialEmail: '',
        howDidYouKnow: '',
      });
      setFileName('');
      formRef.current?.reset();
    } catch (err) {
      console.error('Submit error:', err);
      alert(err.message || 'Something went wrong. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      {/* ===== HERO ===== */}
      <section className="event-hero">
        <img
          src="/assets/Event_form_bg.png"
          alt=""
          className="event-hero-bg"
        />

        <h1 className="event-hero-title">
          India HR <span className="event-highlight">Confluence</span> 2026
        </h1>
      </section>

      {/* ===== REGISTRATION FORM CARD ===== */}
      <section className="event-form-section">
        <div className="event-form-card">
          <h2 className="event-form-heading">Registration Form</h2>

          <form className="event-form" ref={formRef} onSubmit={handleSubmit}>
            <div className="event-form-group">
              <label className="event-form-label">
                Full Name<span className="event-required">*</span>
              </label>
              <input
                type="text"
                name="fullName"
                placeholder="Full name"
                className="event-form-input"
                value={formData.fullName}
                onChange={handleChange}
                required
              />
            </div>

            <div className="event-form-group">
              <label className="event-form-label">
                Designation<span className="event-required">*</span>
              </label>
              <input
                type="text"
                name="designation"
                placeholder="Designation"
                className="event-form-input"
                value={formData.designation}
                onChange={handleChange}
                required
              />
            </div>

            <div className="event-form-group">
              <label className="event-form-label">
                Company<span className="event-required">*</span>
              </label>
              <input
                type="text"
                name="company"
                placeholder="Company"
                className="event-form-input"
                value={formData.company}
                onChange={handleChange}
                required
              />
            </div>

            <div className="event-form-group">
              <label className="event-form-label">
                Contact Number<span className="event-required">*</span>
              </label>
              <input
                type="tel"
                name="contactNumber"
                placeholder="Contact Number"
                className="event-form-input"
                value={formData.contactNumber}
                onChange={handleChange}
                required
              />
            </div>

            <div className="event-form-group">
              <label className="event-form-label">
                Personal Email ID<span className="event-required">*</span>
              </label>
              <input
                type="email"
                name="personalEmail"
                placeholder="Email ID"
                className="event-form-input"
                value={formData.personalEmail}
                onChange={handleChange}
                required
              />
            </div>

            <div className="event-form-group">
              <label className="event-form-label">
                Official Email ID<span className="event-required">*</span>
              </label>
              <input
                type="email"
                name="officialEmail"
                placeholder="Email ID"
                className="event-form-input"
                value={formData.officialEmail}
                onChange={handleChange}
                required
              />
            </div>

            <div className="event-form-group">
              <label className="event-form-label">
                How did you know<span className="event-required">*</span>
              </label>
              <select
                name="howDidYouKnow"
                className="event-form-select"
                value={formData.howDidYouKnow}
                onChange={handleChange}
                required
              >
                <option value="" disabled>
                  -Select-
                </option>
                <option value="social-media">Social Media</option>
                <option value="friend-colleague">Friend / Colleague</option>
                <option value="email">Email</option>
                <option value="website">Website</option>
                <option value="other">Other</option>
              </select>
            </div>

            <div className="event-form-group">
              <label className="event-form-label">
                Upload Your image<span className="event-required">*</span>{' '}
                <span className="event-form-sublabel">(JPG and PDF)</span>
              </label>

              <div className="event-file-upload">
                <label htmlFor="event-file-input" className="event-file-btn">
                  Choose File
                </label>
                <input
                  id="event-file-input"
                  type="file"
                  accept=".jpg,.jpeg,.pdf"
                  className="event-file-input"
                  ref={fileInputRef}
                  onChange={handleFileChange}
                />
                <span className="event-file-name">
                  {fileName || '(Regarding Social Media Poster)'}
                </span>
              </div>
            </div>

            <button type="submit" className="event-submit-btn" disabled={submitting}>
              <span className="event-submit-text">
                {submitting ? 'Submitting...' : 'Submit'}
              </span>
              <span className="event-submit-arrow">
                <svg
                  width="8"
                  height="12"
                  viewBox="0 0 8 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 1L6 6L1 11"
                    stroke="#222664"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
            </button>
          </form>
        </div>
      </section>
    </>
  );
}

export default EventPage;